import { render, staticRenderFns } from "./ChooseLocationMulti.vue?vue&type=template&id=0560885e&scoped=true"
import script from "./ChooseLocationMulti.vue?vue&type=script&lang=js"
export * from "./ChooseLocationMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560885e",
  null
  
)

export default component.exports